// Recent marketplace searches, persisted per device.
//
// localStorage rather than the account: it survives logout, costs no request
// on a screen we've spent the whole overhaul making instant, and the terms
// are innocuous ("barber", "balayage"). Newest first, deduped
// case-insensitively so re-running a search promotes it instead of
// duplicating it, and capped so the list never pushes results off screen.
const KEY = 'beu.recentSearches.v1';
const MAX = 6;

export const getRecentSearches = () => {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed.filter((t) => typeof t === 'string') : [];
    } catch (err) {
        // Private mode / corrupt value - behave as if there's no history.
        return [];
    }
};

export const addRecentSearch = (term) => {
    const trimmed = (term || '').trim();
    // One-character terms are almost always mid-typing, not an intent.
    if (trimmed.length < 2) return getRecentSearches();
    const existing = getRecentSearches().filter(
        (t) => t.toLowerCase() !== trimmed.toLowerCase()
    );
    const next = [trimmed, ...existing].slice(0, MAX);
    try {
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch (err) {
        // Storage full or unavailable - the in-memory list still updates.
    }
    return next;
};

export const removeRecentSearch = (term) => {
    const next = getRecentSearches().filter(
        (t) => t.toLowerCase() !== (term || '').toLowerCase()
    );
    try {
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch (err) {
        // ignore
    }
    return next;
};

export const clearRecentSearches = () => {
    try {
        localStorage.removeItem(KEY);
    } catch (err) {
        // ignore
    }
    return [];
};
